export default __webpack_public_path__ + "static/media/Northword Lines6.2cdfcc76.png";